import { Table, Text } from '@factorialco/deprecated-design-system'
import {
  PayrollConceptFragment,
  TimeSettingsCustomTimeRangeCategoryFragment,
} from 'generated/resources/graphql'
import { isString } from 'lodash'

import { PayrollConceptSelect } from 'modules/compensations/components/PayrollConceptSelectField'
import { PayrollConceptWithCategory } from 'modules/compensations/components/PayrollConceptSelectField/CategorizedPayrollConceptUtil'

interface Props {
  timeCategory: TimeSettingsCustomTimeRangeCategoryFragment
  payrollConcept: PayrollConceptFragment | undefined
  payrollConcepts: PayrollConceptWithCategory[]
  onRowChanged: (timeCategoryId: string, payrollConceptId: string) => void
}

const TimeReimbursementRow = ({
  timeCategory,
  payrollConcept,
  payrollConcepts,
  onRowChanged,
}: Props) => {
  return (
    <Table.Row>
      <Table.Cell sticky={{ position: 'left', delimiter: true }}>
        <Text.Normal>{timeCategory.name}</Text.Normal>
      </Table.Cell>
      <Table.Cell>
        <PayrollConceptSelect
          payrollConcepts={payrollConcepts}
          value={payrollConcept?.id ? [payrollConcept.id] : []}
          onChange={(payrollConceptId) => {
            isString(payrollConceptId) && onRowChanged(timeCategory.id, String(payrollConceptId))
          }}
        />
      </Table.Cell>
    </Table.Row>
  )
}

export default TimeReimbursementRow
